import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';

/** The reason selector extends the existing suspicious-vehicle feature. */
export const isSuspiciousReasonFilterEnabled = (): boolean =>
  isFeatureEnabled(featureFlags.SOURCING_SUSPICIOUS_VEHICLES) &&
  isFeatureEnabled(featureFlags.SOURCING_SUSPICIOUS_REASON_FILTER);
